'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MODE = exports.MODE = {
  LIST: 'list',
  TAGS: 'tags',
  COUNTER: 'counter',
  SINGLE: 'single'
};